import { useQuery } from '@hooks/reactQuery';

import { getNetworkElementConfigurations } from '@api/manageNetworkElementConfigurations';

import { extractQueryParams } from '@utils/common';

import {
	INetworkElementConfigurationsDTO,
} from '@interfaces/networkElementConfigurations/dto/networkElementConfigurationsDTO';
import { INetworkElementConfiguration } from '@interfaces/networkElementConfigurations/networkElementConfigurations';

import { refetchOptions } from '@constants/common';
import { NETWORK_ELEMENT_CONFIGURATIONS } from '@constants/queryKeys';

interface IUseQueryNetworkElementConfigurationsReturned {
	networkElementConfigurations: INetworkElementConfiguration[];
	countOfRecords: number;
	isLoadingNetworkElementConfigurations: boolean;
}

const useQueryNetworkElementConfigurations = (
	params: INetworkElementConfigurationsDTO,
): IUseQueryNetworkElementConfigurationsReturned => {
	const {
		page,
		pageSize,
	} = params;

	const {
		data,
		isLoading,
		isFetching,
	} = useQuery({
		queryKey: [NETWORK_ELEMENT_CONFIGURATIONS, params],
		queryFn: extractQueryParams(getNetworkElementConfigurations),
		enabled: [!!page, !!pageSize],
		...refetchOptions,
	});

	return {
		networkElementConfigurations: data?.items || [],
		countOfRecords: data?.count || 0,
		isLoadingNetworkElementConfigurations: (isLoading && !!data)
			|| isFetching,
	};
};

export default useQueryNetworkElementConfigurations;
